import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ExportService } from '../../services/export.service';
import { throwDialogContentAlreadyAttachedError } from '@angular/cdk/dialog';


@Component({
  selector: 'file-export-dialog',
  templateUrl: './file-export-dialog.component.html',
  styleUrls: ['./file-export-dialog.component.scss']
})
export class FileExportDialogComponent {
  isExpanded = false;
  transactiontype: string;
  filetype: string="excel";
  loading: boolean = false;
  errorMessage: string = '';
  source: string = '';
  isdownloaded: boolean = false;

  constructor(public dialogRef: MatDialogRef<FileExportDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any
    , public exportService: ExportService) {
    this.transactiontype = data.transactiontype;
    this.source = data.source;
  }
  toggleExpand(event: Event) {
    event.preventDefault(); // Prevent the default link behavior
    this.isExpanded = !this.isExpanded;
  }
  setfiletype(filetype: string): void {
    this.errorMessage = '';
    this.filetype = filetype;
    if (filetype.toLowerCase() == 'excel') {
      const element = document.querySelector<HTMLDivElement>('#dv_pdf');
      element.classList.remove('highlight');
      const element1 = document.querySelector<HTMLDivElement>('#dv_excel');
      element1.classList.add('highlight');
    }
    else {
      const element = document.querySelector<HTMLDivElement>('#dv_pdf');
      element.classList.add('highlight');
      const element1 = document.querySelector<HTMLDivElement>('#dv_excel');
      element1.classList.remove('highlight');
    }

  }
  onAccept(): void {
    this.loading = true;
    if (this.filetype == '' || this.filetype == undefined) {
      this.errorMessage = 'Please select a file type to proceed';
      this.loading = false;
    }
    else {
      if (this.filetype.toLowerCase() == 'excel') {
        if (this.source == "walletdetails") {
          if (this.transactiontype.toLowerCase() == "earned") {
            this.exportService.excelDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "redeemed") {
            this.exportService.excelDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.excelDownload(this.source, false, true);
          }
        }

        else if (this.source == "rewards") {
          if (this.transactiontype.toLowerCase() == "earned") {
            this.exportService.excelDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "redeemed") {
            this.exportService.excelDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.excelDownload(this.source, false, true);
          }
        }
        else if (this.source == "cash") {
          if (this.transactiontype.toLowerCase() == "cashearn") {
            this.exportService.excelDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "cashspend") {
            this.exportService.excelDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.excelDownload(this.source, false, true);
          }
        }
      }

      else if (this.filetype.toLowerCase() == 'pdf') {
        if (this.source == "walletdetails") {
          if (this.transactiontype.toLowerCase() == "earned") {
            this.exportService.pdfDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "redeemed") {
            this.exportService.pdfDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.pdfDownload(this.source, false, true);
          }
        }
        else if (this.source == "rewards") {

          if (this.transactiontype.toLowerCase() == "earned") {
            this.exportService.pdfDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "redeemed") {
            this.exportService.pdfDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.pdfDownload(this.source, false, true);
          }
        }
        else if (this.source == "cash") {
          if (this.transactiontype.toLowerCase() == "cashearn") {
            this.exportService.pdfDownload(this.source, true, false);
          }
          else if (this.transactiontype.toLowerCase() == "cashspend") {
            this.exportService.pdfDownload(this.source, false, false);
          }
          else if (this.transactiontype.toLowerCase() == "all") {
            this.exportService.pdfDownload(this.source, false, true);
          }
        }
      }
    }
  }
    onDecline(): void {
      this.dialogRef.close('decline');
    }
  }
